﻿export class User {
    id: number;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    token: string;
    roles: string[];
    tokenExpired: boolean;
    tipo: string;
}
